import { BaseAPI } from './base';
import type { PaginationRequest } from '../../types/base.dto';

export interface PreRatingThreshold {
  id: string | number;
  packageType?: string;
  dominantMode?: string;
  dominantModeRatio?: number;
  thresholdProfitRate?: number;
  sampleOrderCount?: number;
  modeBreakdown?: any;
  statsStartedAt?: string;
  statsEndedAt?: string;
  generatedAt?: string;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
}

export interface PreRatingThresholdListParams extends PaginationRequest {
  packageType?: string;
  dominantMode?: string;
}

export interface PreRatingThresholdUpdateParams {
  thresholdProfitRate: number;
}

export class PreRatingThresholdAPI extends BaseAPI<PreRatingThreshold> {
  constructor() {
    super('/pre-rating-thresholds');
  }
}

export const preRatingThresholdApi = new PreRatingThresholdAPI();

export default preRatingThresholdApi;
